import { useState } from 'react';
import noDataImage from '../../Images/image 2.jpg';

const NoTimelineData = () => {
  const handleImport = () => {
    console.log('Import Project button clicked');
  };

  // Main container - fill the available space
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    padding: '20px',
    backgroundColor: 'transparent'
  };

  // Content wrapper - center content vertically and horizontally
  const contentWrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '400px',
    padding: '40px 20px',
    textAlign: 'center'
  };

  // Icon container styling
  const iconContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px'
  };

  // Icon wrapper with proper dimensions
  const iconWrapperStyle = {
    position: 'relative',
    width: '120px',
    height: '120px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  // Background circle styles
  const iconBackgroundStyle1 = {
    position: 'absolute',
    inset: '0',
    backgroundColor: '#ebebeb',
    borderRadius: '50%',
    opacity: '0.4',
    transform: 'rotate(-12deg)'
  };

  const iconBackgroundStyle2 = {
    position: 'absolute',
    inset: '0',
    backgroundColor: '#ebebeb',
    borderRadius: '50%',
    opacity: '0.6',
    transform: 'rotate(12deg)'
  };

  // Center icon container
  const iconStyle = {
    position: 'relative',
    zIndex: '10',
    width: '80px',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderRadius: '50%',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
  };

  // Image sizing to match design
  const imageStyle = {
    width: '60px',
    height: '60px',
    objectFit: 'contain',
    opacity: '0.75'
  };

  // Typography styles
  const titleStyle = {
    fontSize: '20px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '8px'
  };

  const descriptionStyle = {
    color: '#666',
    marginBottom: '24px',
    lineHeight: '1.5',
    fontSize: '14px'
  };

  // Button styling to match design
  const buttonStyle = {
    padding: '8px 20px',
    backgroundColor: '#f8d44c', // More accurate yellow from the image
    color: '#333',
    fontWeight: '500',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    outline: 'none',
    fontSize: '14px'
  };

  const buttonHoverStyle = {
    backgroundColor: '#f0c73c'
  };

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div style={containerStyle}>
      <div style={contentWrapperStyle}>
        <div style={iconContainerStyle}>
          <div style={iconWrapperStyle}>
            <div style={iconBackgroundStyle1}></div>
            <div style={iconBackgroundStyle2}></div>
            <div style={iconStyle}>
              <img 
                src={noDataImage} 
                alt="No data" 
                style={imageStyle}
              />
            </div>
          </div>
        </div>
        
        <h2 style={titleStyle}>No data found</h2>
        
        <p style={descriptionStyle}>
          Looks like you haven't added any information yet,<br />
          click on the button to import
        </p>
        
        <button
          onClick={handleImport}
          style={{
            ...buttonStyle,
            ...(isHovered ? buttonHoverStyle : {})
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          Import Project
        </button>
      </div>
    </div>
  );
};

export default NoTimelineData;